export const WATERFALL_SEEN_KEY = 'chat-rea.waterfall.lastSeen';

export type SeenStore = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
};

function parseSeen(raw: string): Record<string, string> {
  const parsed: unknown = JSON.parse(raw);
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return {};
  const out: Record<string, string> = {};
  for (const [sessionId, ts] of Object.entries(parsed)) {
    if (typeof ts === 'string' && ts !== '') out[sessionId] = ts;
  }
  return out;
}

export function readLastSeen(store: SeenStore, key = WATERFALL_SEEN_KEY): Record<string, string> {
  let raw: string | null;
  try {
    raw = store.getItem(key);
  } catch {
    return {};
  }
  if (!raw) return {};
  try {
    return parseSeen(raw);
  } catch {
    return {};
  }
}

export function writeLastSeen(
  store: SeenStore,
  sessionId: string,
  ts: string,
  key = WATERFALL_SEEN_KEY,
): Record<string, string> {
  const next = { ...readLastSeen(store, key), [sessionId]: ts };
  store.setItem(key, JSON.stringify(next));
  return next;
}

export function localSeenStore(): SeenStore {
  return {
    getItem(key) {
      try {
        return globalThis.localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    setItem(key, value) {
      try {
        globalThis.localStorage.setItem(key, value);
      } catch {
        return;
      }
    },
  };
}
